import { useTranslation } from 'next-i18next';
import React from 'react';

import { useHubspotChat } from '../../../hooks/useHubspotChat';
import { SupportContactStoryblok } from '../../../types/generated-storyblok';

type Props = {
  blok: SupportContactStoryblok;
};

const SupportContact: React.FC<Props> = ({
  blok: {
    addressLine1,
    addressLine2,
    addressLine3,
    addressLine4,
    addressTitle,
    chatText,
    chatTitle,
    collectingEmail,
    generalTitle,
    infoEmail,
    instagramInsiders,
    instagramMain,
    instagramTitle,
    mediaEmail,
    pressEmail,
    pressTitle,
  },
}) => {
  const { t } = useTranslation('support');
  const { openHandler } = useHubspotChat();

  return (
    <div className="grid-section py-4">
      <ul className="col-span-12 md:col-span-6">
        <li className="font-bold">{generalTitle}</li>
        {infoEmail ? <Link href={infoEmail} isEmail text={infoEmail} /> : null}
        {collectingEmail ? (
          <Link href={collectingEmail} isEmail text={collectingEmail} />
        ) : null}
      </ul>

      <ul className="col-span-12 md:col-span-6">
        <li className="font-bold">{pressTitle}</li>
        {pressEmail ? (
          <Link href={pressEmail} isEmail text={pressEmail} />
        ) : null}
        {mediaEmail ? (
          <Link href={mediaEmail} isEmail text={mediaEmail} />
        ) : null}
      </ul>
      <ul className="col-span-12 md:col-span-6">
        <li className="font-bold">{chatTitle}</li>
        <text>{chatText}</text>

        <button
          className="hyperlink"
          onClick={() => {
            openHandler();
          }}
          type="button"
        >
          {t('openChat')}
        </button>
      </ul>
      <ul className="col-span-12 md:col-span-6">
        <li className="font-bold">{instagramTitle}</li>
        <Link
          href="https://www.instagram.com/avant.arte/"
          text={instagramMain}
        />
        <Link
          href="https://www.instagram.com/avantarteinsiders"
          text={instagramInsiders}
        />
      </ul>
      <ul className="col-span-12 md:col-span-6">
        <li className="font-bold">{addressTitle}</li>
        <li className="">
          <address className="not-italic">
            {addressLine1}
            <br />
            {addressLine2} {addressLine3}
            <br />
            {addressLine4}
          </address>
        </li>
      </ul>
    </div>
  );
};

type LinkProps = {
  href?: string;
  text?: string;
  isEmail?: boolean;
  id?: string;
};

const Link = ({ href, id, isEmail, text }: LinkProps) => {
  const anchor = isEmail ? `mailto:${href}` : href;
  return (
    <li>
      <a
        className="hyperlink"
        href={anchor}
        id={id || anchor}
        rel="noreferrer"
        target="_blank"
      >
        {text}
      </a>
    </li>
  );
};

export default SupportContact;
